import React from "react";
import SimpleSelect from "components/SimpleSelect";
import TextInput from "components/TextInput";
import { useTranslation } from "react-i18next";
import { BNB_DOCUMENT } from "utils";
import { observer } from "mobx-react-lite";
import { BPEStore, Option } from "../ProductEditorStore";
import Tooltip from "components/Tooltip";
import { IconAlertTriangleFilled } from "@tabler/icons-react";

const GeneralInformation = () => {
  const { t } = useTranslation();

  return (
    <div className="pb-6 border-b border-gray-200">
      <div className="text-base font-semibold mb-3">
        {t("productEditor.generalInformation")}
      </div>
      <div className="w-full relative">
        <TextInput
          name="name"
          labelName={t("productEditor.name")}
          placeholder={t("productEditor.enterName")}
          handleChange={(value: string | undefined, name?: string) =>
            BPEStore.onChangeData(name as string, value)
          }
          value={BPEStore.data.name}
          containerClass="w-full"
          required
        />
        {BPEStore.showTooltips?.name && (
          <Tooltip
            content={t("productEditor.name_tooltip")}
            iconClassName="!min-w-5 text-gray-500"
            className="absolute right-2 top-[28px]"
          />
        )}
      </div>
      <div className="flex gap-3">
        <div className="w-full relative">
          <SimpleSelect
            options={BPEStore.optionsLists.din_category as Option[]}
            placeholder={t("productEditor.chooseCategory")}
            labelName={t("productEditor.din_category")}
            name="din_category"
            required
            onChange={(value, name) =>
              BPEStore.onChangeData(name as string, value)
            }
            current={BPEStore.data.din_category}
            displayKey="name"
            containerClassName="w-full"
            noMargin
          />
          {BPEStore.showTooltips?.din_category && (
            <Tooltip
              content={t("productEditor.din_category_tooltip")}
              iconClassName="!min-w-5 text-gray-500"
              className="absolute right-8 top-[28px]"
            />
          )}
        </div>
        <div className="w-full relative">
          <TextInput
            unit={t("productEditor.years")}
            labelName={t("productEditor.life_span")}
            placeholder={t("productEditor.enterYears")}
            type="number"
            min={1}
            name="life_span"
            handleChange={(
              value: string | undefined,
              name: string | undefined
            ) => BPEStore.onChangeData(name as string, value)}
            value={BPEStore.data.life_span}
            containerClass="w-full"
            required
            helper={
              <p
                className="text-gray-500 text-sm"
                dangerouslySetInnerHTML={{
                  __html: t("productEditor.life_span_subtitle", {
                    link: BNB_DOCUMENT,
                  }),
                }}
              ></p>
            }
            noMargin
          />
          {BPEStore.showTooltips?.life_span && (
            <Tooltip
              content={t("productEditor.default_value_tooltip")}
              iconClassName="!min-w-5 text-gray-500"
              className="absolute right-16 top-[28px]"
              icon={
                <IconAlertTriangleFilled
                  size={20}
                  className="text-yellow-500"
                />
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default observer(GeneralInformation);
